import React, { useState } from 'react';
import ReviewOutlinedSVG from 'src/assets/svg/review-outlined.svg';
import { Base, Button } from 'src/components';
import { Flyout } from 'src/componentsTailwind';
import Checkbox from 'src/components/Checkbox/Checkbox';
import CircledIcon from 'src/components/CircledIcon/CircledIcon';

const BuilderPdfDownloadFlyout = (props = {}) => {
  const { setIsOpen, onDownload } = props;

  const [includeSelfReviewComments, setIncludeSelfReviewComments] = useState(true);

  const onClose = () => {
    setIsOpen(null);
    setIncludeSelfReviewComments(true);
  };

  const onSubmitFlyout = async () => {
    await onDownload({
      includeSelfReviewComments
    });

    onClose();
  };

  return (
    <Flyout {...props} onClose={onClose}>
      <Base
        classes='h-full w-full items-center flex flex-col items-stretch justify-between'
        relative
      >
        <div className='mb-10'>
          <div className='flex items-center'>
            <CircledIcon svg={<ReviewOutlinedSVG className='text-purple' />} />
            <h2 className='text-xl font-bold my-auto mt-2 p-0'>
              Download Options
            </h2>
          </div>

          <p className='m-0 p-0'>
            Customize what's included in the PDF export.
          </p>

          <div className='mt-10 border-b border-mid-gray my-3 transform -translate-x-[16px] w-[calc(100%+32px)]' />

          <h1 className='text-black m-0 p-0 text-base'>
            Include Self-Evaluation
          </h1>
          <p className='m-0 p-0 mb-4'>
            Adds all self-evaluation comments to the report export.
          </p>

          <Checkbox
            label='Add self-review comments'
            subLabel='Includes self-evaluation supplemental questions'
            classes='text-black text-base'
            name='selfReviewComments'
            onChange={setIncludeSelfReviewComments}
            value={includeSelfReviewComments}
          />
        </div>

        <div className='flex flex-row flex-wrap w-full max-w-280 gap-4 h-9 2xl:h-[39.5px] xl:ml-auto xl:mr-0 justify-center xl:justify-end'>
          <Button
            type='button'
            variant='empty-with-border'
            classes='!rounded-md !text-sm !font-normal py-1 xl:ml-auto xl:mr-0 h-full'
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            classes='text-sm py-1 rounded-md transition-colors duration-300 h-full px-6'
            variant='black'
            onClick={onSubmitFlyout}
          >
            Download
          </Button>
        </div>
      </Base>
    </Flyout>
  );
};
export default BuilderPdfDownloadFlyout;
